import { FC } from 'react';
import { Layout } from 'antd';
import styled from 'styled-components';
import { baseStyle } from '../styles';
import Container from 'components/container';
import { useLocation } from 'react-router-dom';

const { Content } = Layout;

interface BaseProps {
  pathFlag: boolean;
  pathFlag2: boolean;
  bottomFlag: boolean;
}

const Base = styled(Content)<BaseProps>`
  ${baseStyle}
  margin-top:${(props) => (props.pathFlag ? `0` : `3.75rem`)};
  z-index: ${(props) => (props.pathFlag2 ? `0` : `9`)};
  margin-bottom: ${(props) => (props.bottomFlag ? `0` : `3.75rem`)};
`;
const pathArray = [
  '/LIHome',
  '/LIPayment',
  '/LIPayment/PaymentDetails',
  '/LIPayment/LifePaymentUpload',
  '/LIPayment/CreditCardSuccess',
  '/LIPolicies',
  '/PoliciesDetail',
  '/PoliciesValues',
  '/PoliciesCorrespondence',
  '/LIPolicyUp',
  '/LISupport',
  '/ContactUs',
  '/UserGuide',
  '/LifeFAQPage',
  '/LifeInbox',
  '/login',
  '/EnquiryFlow',
  '/LifeAccount',
  '/LifeFaqDetailsPage',
  '/MakeClaimPage',
  '/MakeRequestPage',
  '/changePwd',
  '/afterOtpVerification',
  '/afterOtpVerificationSuccess',
  '/ChangeContactInformation',
  '/beneficiaries',
  '/ChangePolicyOptions',
  '/LifechgeRequestOtpVerificationPage',
  '/ChangePaymentArrangement',
  '/LifechgepaymentOtpVerificationPage',
  '/LIBenefiaries',
  '/LifechgepaymentOtpVerificationPage',
  '/PolicyOptionsOtpVerificationPage',
  '/LIBenefiaries/SubmitAfterConfirm',
  '/LIBenefiaries/LifeBeneficiariesOtpVerificationPage',
  '/genbravo/payment/return',
  '/primaryOtpVerificationPage',
  '/secOtpVerificationPage',
  '/mfaOtp',
  '/ClaimEnquiryPage',
  '/SubmitClaimFormPage',
  '/ClaimConfirmPage',
  '/CIOtpVerificationPage',
];

const pathArray2 = ['/register/LifeRegistrationLanding', '/register/LifeRegistrationSubmission', '/forgot/password'];
const pathArray3 = [
  '/MakeClaimPage',
  '/ChangeContactInformation',
  '/LIBenefiaries/SubmitAfterConfirm',
  '/genbravo/payment/return',
  '/ClaimEnquiryPage',
  '/SubmitClaimFormPage',
  '/ClaimConfirmPage',
];

const BravoContent: FC = ({ children }): JSX.Element => {
  const location = useLocation();
  const pathFlag = pathArray.includes(location.pathname);
  const pathFlag2 = pathArray2.includes(location.pathname);
  const bottomFlag = pathArray3.includes(location.pathname);
  return (
    <Base pathFlag={pathFlag} pathFlag2={pathFlag2} bottomFlag={bottomFlag} id="drawer-in">
      <Container pathFlag={pathFlag}>{children}</Container>
    </Base>
  );
};

export default BravoContent;
